module.exports = __webpack_public_path__ + "static/currentlyowned-dcab34d7463a6d339ff7a12ff5984e93.jpg";